import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

interface Error {
  response: {
    status: number
  }
}

export const validateToken = (token: string, scheduleId: string): Promise<void> => {

  const endpoint = apiEndpoints.SCHEDULE_TOKEN_VALIDATION(scheduleId)

  return new Promise<void> ((resolve, reject) => {
    axios.post(endpoint, { token })
      .then(() => resolve())
      .catch((error: Error) => reject(error.response.status))
  })
}

